// SEETRUE — global behavior: header, drawers (menu/search/wishlist), product-card arrows,
// swatch paging, edge-colour sampling, wishlist. Cart uses Dawn's cart drawer.

(function () {
  'use strict';

  var body = document.body;
  var overlay = document.getElementById('overlay');
  var header = document.querySelector('.header');
  var menuPanel = document.getElementById('menuPanel');
  var searchPanel = document.getElementById('searchPanel');
  var searchInput = document.getElementById('searchInput');
  var wishlistPanel = document.getElementById('wishlistPanel');
  var wishlistBody = document.getElementById('wishlistBody');

  function anyPanelOpen(except) {
    return [menuPanel, searchPanel, wishlistPanel].some(function (p) {
      return p && p !== except && p.classList.contains('is-open');
    });
  }
  function closePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (!anyPanelOpen(panel) && overlay) overlay.classList.remove('is-visible');
  }
  function openPanel(panel) {
    if (!panel) return;
    panel.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
  }

  /* ---------- header: border on scroll, hide at bottom, transparent over hero ---------- */
  if (header) {
    var isOverlay = header.classList.contains('header--overlay');
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      var atBottom = y + window.innerHeight >= document.documentElement.scrollHeight - 8;
      header.classList.toggle('is-hidden-bottom', atBottom);
      if (isOverlay) header.classList.toggle('is-hero-top', y < 30);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- side menu ---------- */
  bindOpen('menuOpen', menuPanel);
  bindClose('menuClose', menuPanel);
  document.querySelectorAll('.menu-item__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.menu-item').classList.toggle('is-expanded');
    });
  });

  /* ---------- search ---------- */
  bindClose('searchClose', searchPanel);
  document.querySelectorAll('.js-search-open').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openPanel(searchPanel);
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 450);
    });
  });
  var searchReset = document.getElementById('searchReset');
  if (searchReset) searchReset.addEventListener('click', function () {
    if (searchInput) { searchInput.value = ''; searchInput.focus(); searchInput.dispatchEvent(new Event('input')); }
  });

  /* predictive search → render into the seetrue result cards */
  var searchResults = document.getElementById('searchResults');
  if (searchInput && searchResults) {
    var defaultResultsHTML = searchResults.innerHTML;
    var searchTimer;
    var imgOf = function (it) {
      if (it.featured_image && it.featured_image.url) return it.featured_image.url;
      if (it.image && it.image.url) return it.image.url;
      if (typeof it.image === 'string') return it.image;
      return '';
    };
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = defaultResultsHTML; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data.resources && data.resources.results) || {};
            var items = (res.products || []).concat(res.collections || []);
            if (!items.length) { searchResults.innerHTML = '<p class="search-empty">nothing found</p>'; return; }
            searchResults.innerHTML = items.slice(0, 6).map(function (it) {
              var img = imgOf(it);
              return '<a class="search-card" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="' + it.title + '">' : '') + '<span>' + it.title + '</span></a>';
            }).join('');
          })
          .catch(function () {});
      }, 220);
    });

    /* frequently-searched terms → fill the box and run the live search */
    document.querySelectorAll('.search-panel__links a[data-term]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        searchInput.value = link.getAttribute('data-term');
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        searchInput.focus();
      });
    });
  }

  /* ---------- wishlist (localStorage) ---------- */
  var WISH_KEY = 'seetrue-wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWishlist(arr) { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); }

  function renderWishlist() {
    if (!wishlistBody) return;
    var list = getWishlist();
    if (!list.length) {
      wishlistBody.innerHTML = '<div class="wishlist-empty"><svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><p>your wishlist is empty</p></div>';
      return;
    }
    wishlistBody.innerHTML = list.map(function (item) {
      return '<div class="wishlist-item">' +
        '<a class="wishlist-item__img" href="' + item.url + '">' + (item.img ? '<img src="' + item.img + '" alt="' + item.name + '" />' : '') + '</a>' +
        '<div class="wishlist-item__info"><a class="wishlist-item__name" href="' + item.url + '">' + item.name + '</a><span class="wishlist-item__price">' + item.price + '</span></div>' +
        '<button class="wishlist-item__remove" data-id="' + item.id + '" aria-label="remove"><svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg></button>' +
        '</div>';
    }).join('');
    wishlistBody.querySelectorAll('.wishlist-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.id;
        setWishlist(getWishlist().filter(function (x) { return x.id !== id; }));
        syncHearts(id, false);
        renderWishlist();
      });
    });
  }
  function syncHearts(id, active) {
    document.querySelectorAll('.card-wish-btn[data-wish-id="' + id + '"]').forEach(function (b) {
      b.classList.toggle('is-active', active);
    });
  }

  bindClose('wishlistClose', wishlistPanel);
  var wishlistOpen = document.getElementById('wishlistOpen');
  if (wishlistOpen) wishlistOpen.addEventListener('click', function () {
    renderWishlist();
    openPanel(wishlistPanel);
  });

  /* inject wishlist heart into every product card (idempotent: skips cards that already have one) */
  function wireWishHeart(card) {
    var frame = card.querySelector('.product-card__frame');
    if (!frame || frame.querySelector('.card-wish-btn')) return;
    var id = card.dataset.wishId || (card.querySelector('.product-card__name') || {}).textContent;
    if (!id) return;
    id = String(id).trim().replace(/\s+/g, '-').toLowerCase();
    var name = (card.querySelector('.product-card__name') || {}).textContent || '';
    var price = (card.querySelector('.product-card__price') || {}).textContent || '';
    var imgEl = card.querySelector('.product-card__img-wrap img');
    var img = imgEl ? imgEl.getAttribute('src') : '';
    var url = card.dataset.href || '#';

    var btn = document.createElement('button');
    btn.className = 'card-wish-btn';
    btn.setAttribute('aria-label', 'add to wishlist');
    btn.setAttribute('data-wish-id', id);
    btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    if (getWishlist().some(function (x) { return x.id === id; })) btn.classList.add('is-active');

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var list = getWishlist();
      var idx = list.findIndex(function (x) { return x.id === id; });
      if (idx > -1) { list.splice(idx, 1); syncHearts(id, false); }
      else { list.push({ id: id, name: name.trim(), price: price.trim(), img: img, url: url }); syncHearts(id, true); }
      setWishlist(list);
    });
    frame.appendChild(btn);
  }

  /* ---------- product card click → navigate ---------- */
  function wireCardLink(card) {
    if (card.dataset.stLink) return;
    card.dataset.stLink = '1';
    var frame = card.querySelector('.product-card__frame');
    if (!frame) return;
    card.style.cursor = 'pointer';
    frame.addEventListener('click', function (e) {
      if (e.target.closest('.card-wish-btn') || e.target.closest('.card-arrow') || e.target.closest('.swatches')) return;
      window.location.href = card.dataset.href;
    });
  }

  /* ---------- overlay + Escape close everything ---------- */
  if (overlay) overlay.addEventListener('click', function () {
    closePanel(menuPanel); closePanel(searchPanel); closePanel(wishlistPanel);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePanel(menuPanel); closePanel(searchPanel); closePanel(wishlistPanel); }
  });

  /* ---------- product card image arrows (slide transition) ---------- */
  function wireCardArrows(card) {
    if (card.dataset.stArrows) return;
    card.dataset.stArrows = '1';
    var images;
    try { images = JSON.parse(card.dataset.images); } catch (err) { return; }
    if (!images || images.length < 2) return;
    var wrap = card.querySelector('.product-card__img-wrap');
    var img = wrap.querySelector('img');
    var index = 0, animating = false;

    // Preload every angle once the card scrolls into view, so arrow swaps are
    // instant with no flash of the previous image while the next one downloads.
    // (Lazy — nothing extra loads until the card is near the viewport, so initial
    // page load is unchanged.)
    var preloaded = [];
    var didPreload = false;
    function preloadAll() {
      if (didPreload) return;
      didPreload = true;
      images.forEach(function (src) {
        var p = new Image();
        p.src = src;
        preloaded.push(p); // keep a ref so it isn't GC'd before it caches
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { preloadAll(); io.disconnect(); }
        });
      }, { rootMargin: '300px' });
      io.observe(card);
    } else {
      preloadAll();
    }

    // Core slide: bring `targetSrc` in from the `dir` side (1 = from the right,
    // -1 = from the left) with the shared transition. Used by both the prev/next
    // arrows and the colour swatches so they animate identically.
    function animateTo(targetSrc, dir) {
      if (animating || !targetSrc) return;
      animating = true;
      var at = images.indexOf(targetSrc);
      if (at >= 0) index = at; // keep arrow position in sync when the target is a known angle
      var incoming = document.createElement('img');
      incoming.alt = img.alt;
      incoming.style.cssText =
        'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;' +
        'transform:translateX(' + (dir * 100) + '%);z-index:2;';
      incoming.src = targetSrc;

      function begin() {
        wrap.insertBefore(incoming, img.nextSibling);
        // Two frames so the offscreen start position is painted before transitioning.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            incoming.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
            img.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
            incoming.style.transform = 'translateX(0)';
            img.style.transform = 'translateX(' + (-dir * 100) + '%)';
          });
        });
        setTimeout(function () {
          img.srcset = '';
          img.sizes = '';
          img.src = targetSrc;
          img.style.transition = 'none';
          img.style.transform = 'none';
          if (incoming.parentNode) wrap.removeChild(incoming);
          animating = false;
        }, 520);
      }

      // Only start sliding once the incoming image is actually ready to paint.
      // Preloaded (cached) images resolve immediately, so this is imperceptible.
      if (incoming.complete && incoming.naturalWidth) {
        begin();
      } else if (incoming.decode) {
        incoming.decode().then(begin).catch(begin);
      } else {
        incoming.onload = begin;
        incoming.onerror = begin;
      }
    }

    function slide(dir) {
      animateTo(images[(index + dir + images.length) % images.length], dir);
    }

    // Slide straight to a specific image (colour swatches use this). Direction is
    // chosen from where the target sits relative to the current image.
    function slideToSrc(src) {
      if (!src || animating) return;
      if (img.getAttribute('src') === src) return; // already showing this colour
      var at = images.indexOf(src);
      if (at === index) return;
      animateTo(src, at >= 0 ? (at > index ? 1 : -1) : 1);
    }
    card._stSlideTo = slideToSrc;

    var prev = card.querySelector('.card-arrow--prev');
    var next = card.querySelector('.card-arrow--next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); slide(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); slide(1); });
  }

  /* ---------- colour swatches: click a colour → slide the card to its photo;
     ">" pages through colours in groups of 4 (each dot carries its colour's image) ---------- */
  function wireCardSwatch(card) {
    if (card.dataset.stSwatch) return;
    card.dataset.stSwatch = '1';
    var swatches;
    try { swatches = JSON.parse(card.dataset.swatches); } catch (err) { return; }
    if (!swatches || !swatches.length) return;
    var dots = card.querySelectorAll('.swatches i');
    if (!dots.length) return;
    var shownImg = card.querySelector('.product-card__img-wrap img');

    // Point each visible dot at one colour: its swatch colour + associated photo.
    function assign(group) {
      dots.forEach(function (dot, i) {
        var o = group[i];
        if (o) {
          dot.style.background = o.c;
          dot.style.visibility = 'visible';
          dot._img = o.img || '';
        } else {
          dot.style.background = 'transparent';
          dot.style.visibility = 'hidden';
          dot._img = '';
        }
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); // don't fall through to the card's navigate handler
        if (!dot._img) return;
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        dot.classList.add('is-active');
        if (card._stSlideTo) card._stSlideTo(dot._img);
      });
    });

    // Page through more than four colours.
    var more = card.querySelector('.swatches__more');
    if (more && swatches.length > 4) {
      var sets = [];
      for (var i = 0; i < swatches.length; i += 4) sets.push(swatches.slice(i, i + 4));
      var setIndex = 0;
      more.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setIndex = (setIndex + 1) % sets.length;
        assign(sets[setIndex]);
        dots.forEach(function (d) { d.classList.remove('is-active'); });
      });
    }

    // Initial: give the first four dots their images; highlight the colour whose
    // photo is already showing, if any.
    assign(swatches.slice(0, 4));
    if (shownImg) {
      var cur = shownImg.getAttribute('src');
      dots.forEach(function (dot) { if (dot._img && dot._img === cur) dot.classList.add('is-active'); });
    }
  }

  /* Wire every product card. Idempotent per card, so infinite-scroll can call
     window.SeetrueCards.init(document) after appending a page and only fresh cards get wired. */
  function initProductCards(root) {
    root = root || document;
    root.querySelectorAll('.product-card').forEach(wireWishHeart);
    root.querySelectorAll('.product-card[data-href]').forEach(wireCardLink);
    root.querySelectorAll('.product-card').forEach(wireCardArrows);
    root.querySelectorAll('.product-card').forEach(wireCardSwatch);
  }
  initProductCards(document);
  window.SeetrueCards = { init: initProductCards };

  /* ---------- drag-to-scroll for card rows (mouse; touch scrolls natively) ----------
     Capture is engaged only AFTER the pointer moves past a threshold, so a plain
     click on an arrow / card is never captured and fires normally. */
  document.querySelectorAll('.product-row').forEach(function (row) {
    var pressed = false, dragging = false, startX = 0, startScroll = 0, pid = null, snapRaf = null;

    /* eased glide to a scrollLeft (snap kept off during the animation, restored after) */
    function glideTo(left) {
      if (snapRaf) cancelAnimationFrame(snapRaf);
      row.classList.add('is-dragging');
      var startL = row.scrollLeft, dist = left - startL, t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / 420);
        row.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3));
        if (p < 1) { snapRaf = requestAnimationFrame(step); }
        else { snapRaf = null; row.classList.remove('is-dragging'); }
      }
      snapRaf = requestAnimationFrame(step);
    }
    /* glide so the card nearest the row's left edge aligns to it */
    function snapToNearest() {
      var rowLeft = row.getBoundingClientRect().left, best = 0, bestDist = Infinity;
      for (var i = 0; i < row.children.length; i++) {
        var delta = row.children[i].getBoundingClientRect().left - rowLeft;
        if (Math.abs(delta) < bestDist) { bestDist = Math.abs(delta); best = delta; }
      }
      glideTo(row.scrollLeft + best);
    }

    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || (e.button && e.button !== 0)) return;
      if (snapRaf) { cancelAnimationFrame(snapRaf); snapRaf = null; row.classList.remove('is-dragging'); }
      pressed = true; dragging = false;
      startX = e.clientX; startScroll = row.scrollLeft; pid = e.pointerId;
    });
    row.addEventListener('pointermove', function (e) {
      if (!pressed) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < 5) return;
        dragging = true;
        row.classList.add('is-dragging');
        try { row.setPointerCapture(pid); } catch (_) {}
      }
      row.scrollLeft = startScroll - dx;
    });
    function end() { if (!pressed) return; pressed = false; if (dragging) snapToNearest(); }
    row.addEventListener('pointerup', end);
    row.addEventListener('pointercancel', end);
    row.addEventListener('dragstart', function (e) { if (dragging) e.preventDefault(); });
    // a completed drag must not trigger a card click-through
    row.addEventListener('click', function (e) {
      if (dragging) { e.preventDefault(); e.stopPropagation(); dragging = false; }
    }, true);
  });

  function bindOpen(id, panel) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', function () { openPanel(panel); });
  }
  function bindClose(id, panel) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', function () { closePanel(panel); });
  }
})();
